const RepositorySettings = {
    apiBaseURL: '',
    apiTokenName: '',
    contentType: '',
}

export default RepositorySettings;